import { render, staticRenderFns } from "./RelativeDatePicker.vue?vue&type=template&id=0af2b5f0&"
import script from "./RelativeDatePicker.vue?vue&type=script&lang=js&"
export * from "./RelativeDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports